import { useAuthContext } from '@/context/AuthProvider';
import { CognitoGroup } from '@/models/User';

export const useUserRole = () => {
  const { user } = useAuthContext();
  const roles = user?.roles ?? [CognitoGroup.Buyer];

  const isSuperAdmin = roles.includes(CognitoGroup.SuperAdmin);
  // isAdmin is true for both Admin and SuperAdmin so all existing call sites
  // automatically cover SuperAdmin without per-consumer migration.
  const isAdmin = roles.includes(CognitoGroup.Admin) || isSuperAdmin;
  const isAdvisor = roles.includes(CognitoGroup.Advisor);
  const isBuyer = roles.includes(CognitoGroup.Buyer);

  return {
    roles,
    isSuperAdmin,
    isAdmin,
    isAdvisor,
    isBuyer,
    isInternal: isAdmin || isAdvisor,
    isClient: isBuyer,
    canAccessAdmin: isAdmin,
    canAccessAdvancedData: isSuperAdmin,
    canViewAllProperties: isAdmin || isAdvisor,
    canManageProperties: isAdmin || isAdvisor,
    // Backward-compat — some components still read a single role for display.
    // Use roles[] for any real logic; remove once all consumers are updated.
    platformRole: roles[0] ?? CognitoGroup.Buyer,
  };
};
